// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackNewShippingInfoSetParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/account/trackNewShippingInfoSet";

const useTrackNewShippingInfoSet = (
    parameters: TrackNewShippingInfoSetParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.newShippingInfoSet, parameters, options);
};

export default useTrackNewShippingInfoSet;
